export default {
  note: {
    title: 'Speciale opmerkingen:',
    description:
      'We doen ons best om verzoeken te honoreren, maar kunnen geen wijzigingen doorvoeren die de prijs beïnvloeden.',
    placeholder: 'Speciaal verzoek toevoegen',
  },
  buttons: {
    add: '+ Item toevoegen',
    update_item: 'Bijwerken',
    add_to_card: 'Toevoegen aan winkelwagen',
  },
  alcohol_warning: 'Dit is een artikel met leeftijdsbeperking.',
  caffeine_warning:
    'Verhoogd cafeïnegehalte. Niet aanbevolen voor kinderen of zwangere of borstvoedende vrouwen.{{value}}',
  error_messages: {
    product_unavailable: 'Uitverkocht!',
    item_not_added: 'Het item kon niet worden toegevoegd. Probeer het opnieuw.',
  },
  success_messages: {
    item_added: 'Item succesvol toegevoegd',
  },
};
